import React, { useState } from 'react';
import OnboardingShell from '../components/OnboardingShell';

const InstructionsStep = ({ steps, completed, config, onContinue }) => {
  const [agreed, setAgreed] = useState(false);
  const rec = config?.record || {};
  const recorded = !!(rec.screen || rec.camera || rec.audio);
  const recordedParts = [
    rec.screen && 'screen',
    rec.camera && 'camera',
    (rec.audio || rec.screen) && 'audio',
  ].filter(Boolean);
  const recordingText = recordedParts.length
    ? `Your ${recordedParts.join(', ').replace(/, ([^,]*)$/, ' and $1')} will be recorded.`
    : 'This interview is not recorded.';

  return (
    <OnboardingShell steps={steps} completed={completed} activeKey="instruction" recording={recorded}
      title="Before your interview" subtitle="Please read and confirm before you begin.">
      <div className="mx-auto max-w-xl space-y-3 text-left text-sm leading-6 text-slate-700 dark:text-slate-200">
        <p>{recordingText} An AI interviewer will conduct and analyze your interview. HR will review the results before deciding the next step.</p>
        <p>Answer honestly and in your own words. You can ask for clarification or ask to skip a difficult question.</p>
        <p>If you have a technical issue, refresh this page to rejoin your interview.</p>
      </div>
      <label className="mx-auto mt-6 flex max-w-xl cursor-pointer items-start gap-3 rounded-lg bg-slate-100 p-4 text-left dark:bg-white/5">
        <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)}
          className="mt-1 h-4 w-4 accent-primary-600" />
        <span className="text-sm text-slate-700 dark:text-slate-200">
          I understand the interview and recording conditions above.
        </span>
      </label>
      <button type="button" onClick={onContinue} disabled={!agreed}
        className="mt-5 rounded-lg bg-primary-600 px-7 py-3 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-40">
        Start interview
      </button>
    </OnboardingShell>
  );
};

export default InstructionsStep;
